import { useSynchronousStorage } from './useSynchronousStorage';

export const useSessionStorage = useSynchronousStorage(
  () => window.sessionStorage,
);
